import { proxy } from "valtio/vanilla";
import { SiteClusterFeature, SiteFeature as SiteFeatureType } from "src/js/api/siteGeometry.types";

export type SiteFeature = SiteFeatureType;

export type SiteGeometryStore = {
  siteFeatures: SiteFeature[];
  clusters: SiteClusterFeature[];
  boundsDistance: number;
  activeRequestAbort?: AbortController["abort"];
  loading: boolean;
  changeCount: number;
};

export const getInitialSiteGeometryStore = (): SiteGeometryStore => ({
  siteFeatures: [],
  clusters: [],
  boundsDistance: 0,
  loading: false,
  /**
   * Used by SitesMVTLayer to be reactive to site
   * changes and invalidate/refetch MVT tiles.
   */
  changeCount: 0,
});

export const siteGeometryStore = proxy<SiteGeometryStore>(getInitialSiteGeometryStore());
